/* Shipping-protection client logic.
 * Reads #hcs-sp-config and routes protection reconcile through HCSCart.
 */
(function () {
  'use strict';

  var CFG = {};
  try {
    var node = document.getElementById('hcs-sp-config');
    if (node) CFG = JSON.parse(node.textContent) || {};
  } catch (e) {
    CFG = {};
  }
  if (!CFG.variantMap) return;

  var SP_PCT = CFG.percentage;
  var SP_MIN = CFG.minPrice;
  var SP_MAX = CFG.maxPrice;

  var VM = CFG.variantMap;

  var TOGGLE_KEY = 'hcs_sp_toggle';
  var stored = sessionStorage.getItem(TOGGLE_KEY);
  var toggleOn = (stored === null || stored === 'true');

  // Lookup of all shipping-protection tier variant IDs.
  var SP_VARIANT_IDS = {};
  Object.keys(VM).forEach(function (p) { SP_VARIANT_IDS[VM[p]] = true; });

  // Re-entrancy guard for checkout race protection.
  var processing = false;

  // Single tier-calculation source; price paint comes from refreshUI.
  function calcPrice(cartCents) {
    var raw = cartCents * SP_PCT / 100;
    var minC = Math.round(SP_MIN * 100);
    var maxC = Math.round(SP_MAX * 100);
    var clamped = Math.max(minC, Math.min(maxC, raw));
    var steps = Math.round((clamped - minC) / 10);
    return Math.min(minC + steps * 10, maxC);
  }

  function fmt(cents) { return '$' + (cents / 100).toFixed(2); }

  function routeWithJson(name, fallback) {
    var configured = window.routes && window.routes[name];
    var url = configured || fallback;
    return /\.js(?:\?|$)/.test(url) ? url : url + '.js';
  }

  function checkoutUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/') + 'checkout';
  }

  function variantId(item) {
    return String(item.variant_id || item.id);
  }

  function isProtection(item) {
    return item.handle === 'shipping-protection' || !!SP_VARIANT_IDS[variantId(item)];
  }

  function nonProtectionSubtotal(cart) {
    return (cart.items || []).reduce(function (total, item) {
      return isProtection(item) ? total : total + (parseInt(item.final_line_price, 10) || 0);
    }, 0);
  }

  // Emptiness uses quantity so discounted/free merchandise still counts as present.
  function merchandiseQuantity(cart) {
    return (cart.items || []).reduce(function (total, item) {
      return isProtection(item) ? total : total + (parseInt(item.quantity, 10) || 0);
    }, 0);
  }

  function parseJsonResponse(response) {
    return response.text().then(function (text) {
      var data;
      try { data = JSON.parse(text); } catch (e) { data = null; }
      if (!response.ok || !data) throw new Error('Cart request failed');
      return data;
    });
  }

  function verifyProtection(cart, desiredId) {
    var lines = (cart.items || []).filter(isProtection);
    if (!desiredId) {
      if (lines.length !== 0) throw new Error('Shipping protection removal was not confirmed');
      return cart;
    }
    var desired = String(desiredId);
    var quantity = 0;
    var wrongTier = false;
    lines.forEach(function (item) {
      if (variantId(item) === desired) quantity += parseInt(item.quantity, 10) || 0;
      else wrongTier = true;
    });
    if (wrongTier || quantity !== 1) throw new Error('Shipping protection tier was not confirmed');
    return cart;
  }

  function setCheckoutDisabled(disabled) {
    document.querySelectorAll('button[name="checkout"]').forEach(function (button) {
      button.disabled = disabled;
    });
  }

  function errorElement(drawerCheckout) {
    return drawerCheckout
      ? document.getElementById('hcs-sp-error')
      : document.getElementById('cart-errors');
  }

  function clearError(drawerCheckout) {
    var el = errorElement(drawerCheckout);
    if (el) {
      el.textContent = '';
      el.hidden = true;
    }
  }

  function showError(drawerCheckout, message) {
    var el = errorElement(drawerCheckout);
    if (el) {
      el.textContent = message || 'We could not confirm your shipping protection choice. Please try checkout again.';
      el.hidden = false;
    }
  }

  // repairOnly is cleanup-only (no adds), returns { cart, mutated } for repaint control.
  function reconcileProtection(options) {
    options = options || {};
    return fetch(routeWithJson('cart_url', '/cart'), { headers: { 'Accept': 'application/json' } })
      .then(parseJsonResponse)
      .then(function (cart) {
        if (options.repairOnly && merchandiseQuantity(cart) > 0) return { cart: cart, mutated: false };
        var subtotal = nonProtectionSubtotal(cart);
        var desiredId = null;
        if (!options.repairOnly && toggleOn && subtotal > 0) {
          desiredId = VM[calcPrice(subtotal)];
          if (!desiredId) throw new Error('Shipping protection tier is unavailable');
        }

        var updates = {};
        (cart.items || []).forEach(function (item) {
          if (isProtection(item)) updates[variantId(item)] = 0;
        });
        if (desiredId) updates[String(desiredId)] = 1;

        if (Object.keys(updates).length === 0) return { cart: verifyProtection(cart, desiredId), mutated: false };
        return fetch(routeWithJson('cart_update_url', '/cart/update'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(parseJsonResponse).then(function (updatedCart) {
          return { cart: verifyProtection(updatedCart, desiredId), mutated: true };
        });
      });
  }

  // Announced cartData can indicate orphan status without extra fetch.
  function looksOrphaned(cart) {
    if (!cart || !cart.items) return false;
    if (merchandiseQuantity(cart) > 0) return false;
    return cart.items.some(isProtection);
  }

  // Use data-sp-orphaned to avoid needless orphan checks on normal empty-cart views.
  function looksOrphanedOnPage() {
    var surface = document.querySelector('cart-drawer') || document.querySelector('cart-items');
    return !!surface && !!surface.getAttribute && surface.getAttribute('data-sp-orphaned') === 'true';
  }

  var repairing = false;

  // Queue orphan repair with mutation work so stale responses cannot repaint over newer cart state.
  function repairOrphanProtection() {
    if (repairing) return Promise.resolve();
    repairing = true;
    var work = function () {
      return reconcileProtection({ repairOnly: true }).then(function (outcome) {
        if (!outcome.mutated || !window.HCSCart || typeof window.HCSCart.render !== 'function') {
          return outcome.cart;
        }
        return window.HCSCart.render(outcome.cart).then(function () { return outcome.cart; });
      });
    };
    var result = (window.HCSCart && typeof window.HCSCart.enqueueMutation === 'function')
      ? window.HCSCart.enqueueMutation(work)
      : work();

    return result.then(function () {
      refreshUI();
    }).catch(function (error) {
      console.error('Shipping protection orphan repair failed:', error);
    }).then(function () {
      repairing = false;
    });
  }

  // Toggle flip mutates immediately and repaints through HCSCart.render for key coherence.
  function syncToggle() {
    clearError(true);
    var work = function () { return reconcileProtection(); };
    var result = (window.HCSCart && typeof window.HCSCart.enqueueMutation === 'function')
      ? window.HCSCart.enqueueMutation(work)
      : work();

    return result.then(function (outcome) {
      if (window.HCSCart && typeof window.HCSCart.render === 'function') {
        return window.HCSCart.render(outcome.cart);
      }
    }).then(function () {
      /* A re-render restores the Liquid default (checked) on a fresh input, and
         the poller only fires when the SP-excluded total changes — which
         removing SP does not. Resync the checkbox from state explicitly. */
      refreshUI();
    }).catch(function (error) {
      console.error('Shipping protection toggle failed:', error);
      /* Cart still holds the old state — put the toggle back so the two agree. */
      toggleOn = !toggleOn;
      sessionStorage.setItem(TOGGLE_KEY, toggleOn ? 'true' : 'false');
      refreshUI();
      showError(true, 'We could not update your shipping protection. Please try again.');
    });
  }

  document.addEventListener('change', function(e) {
    if (!e.target || e.target.id !== 'hcs-sp-checkbox') return;
    toggleOn = e.target.checked;
    sessionStorage.setItem(TOGGLE_KEY, toggleOn ? 'true' : 'false');
    /* Enable smooth transition after first user interaction */
    var label = e.target.closest('.hcs-sp-toggle');
    if (label && !label.classList.contains('animated')) label.classList.add('animated');
    refreshUI();
    syncToggle();
  });

  /* Removing the protection line from the drawer means "I don't want it":
     flip the toggle OFF so the checkout reconcile does not re-add it, and so
     the button label stops flickering between the with/without-protection
     totals (both writers agree once the toggle is off). The cart line removal
     itself is handled by the drawer's own remove flow — we only sync state. */
  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.closest('.gb-remove-product-shipping-protection')) return;
    toggleOn = false;
    sessionStorage.setItem(TOGGLE_KEY, 'false');
    refreshUI();
  });

  document.addEventListener('click', function(e) {
    if (!e.target) return;
    var btn = e.target.closest('[name="checkout"]');
    if (!btn || (btn.id !== 'CartDrawer-Checkout' && btn.id !== 'checkout')) return;

    /* Already reconciling from a prior click — swallow this one. */
    if (processing) { e.preventDefault(); return; }

    /* Reconcile the cart's shipping-protection line(s) to match the toggle
       BEFORE leaving for checkout. This is idempotent: it reads the live cart
       and sets protection to an absolute quantity (1 when on, 0 when off) via
       /cart/update.js, rather than blindly incrementing with /cart/add.js.
       Safe to re-fire from drawer re-renders, the back button, or a stale line
       carried over from a prior session — protection can never exceed one unit,
       and turning the toggle off removes a previously added line. */
    e.preventDefault();
    processing = true;
    var drawerCheckout = btn.id === 'CartDrawer-Checkout';
    clearError(drawerCheckout);
    setCheckoutDisabled(true);

    var work = function () {
      /* A queued cart render may replace the original button before this work
         starts, so disable the current checkout controls again. */
      setCheckoutDisabled(true);
      return reconcileProtection();
    };
    var result = (window.HCSCart && typeof window.HCSCart.enqueueMutation === 'function')
      ? window.HCSCart.enqueueMutation(work)
      : work();

    result.then(function () {
      window.location.assign(checkoutUrl());
    }).catch(function (error) {
      console.error('Shipping protection reconciliation failed:', error);
      processing = false;
      setCheckoutDisabled(false);
      showError(drawerCheckout);
    });
  });

  function refreshUI() {
    var card = document.getElementById('hcs-sp-card');
    var cb = document.getElementById('hcs-sp-checkbox');
    var priceEl = document.getElementById('hcs-sp-price');
    var btn = document.getElementById('CartDrawer-Checkout');

    if (cb) {
      cb.checked = toggleOn;
    }

    if (!card) return;
    var cartTotal = parseInt(card.dataset.spCartTotal, 10) || 0;
    if (cartTotal <= 0) return;

    var price = calcPrice(cartTotal);

    if (priceEl) priceEl.textContent = fmt(price);

    if (btn) {
      var textEl = btn.querySelector('.button-text');
      if (textEl) {
        var total = toggleOn ? (cartTotal + price) : cartTotal;
        textEl.textContent = 'Checkout \u00b7 ' + fmt(total);
      }
    }
  }

  /* Repaint on every cart change. Both drawer paths publish cartUpdate AFTER
     the DOM is patched — the JSON fast path runs _applyJsonState (which writes
     data-sp-cart-total) first, and the refetch path swaps in freshly rendered
     markup first — so a subscriber always reads the settled total. That is what
     the old 300ms dataset poller was approximating, three wakeups a second
     forever. pubsub.js is deferred and this snippet is inline, so the seam does
     not exist yet while this parses; wait for DOMContentLoaded, which fires
     after deferred scripts run. */
  function watchCart() {
    if (window.HCSCart && typeof window.HCSCart.subscribe === 'function') {
      window.HCSCart.subscribe(function (event) {
        refreshUI();
        if (looksOrphaned(event && event.cartData)) repairOrphanProtection();
      });
    }
    if (looksOrphanedOnPage()) repairOrphanProtection();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCart);
  } else {
    watchCart();
  }

  /* Back/forward-cache restores skip DOMContentLoaded entirely and can
     resurrect a stale data-sp-orphaned snapshot either way, so always ask
     the server rather than trusting the cached DOM here. This still costs
     only a single /cart.js read on a clean cart — reconcileProtection's
     repairOnly branch resolves { mutated: false } without a second request,
     and repairOrphanProtection skips the render entirely in that case, so a
     persisted restore of an unchanged cart never repaints. */
  if (window.addEventListener) {
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) repairOrphanProtection();
    });
  }

  refreshUI();

})();
